/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AuthApiService } from '../../core/http';
import { BaseComponent } from '../../core/components';
import { Component } from '@angular/core';
import { DeepThoughtMenu } from './shared/lists/deepThought.menu';
import { ErrorResponseModel, MenuConfigModel } from '../../core/models';
import { LogService, ModalService, UserService } from '../../core/services';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-deep-thought',
    styleUrls: ['./deep-thought.component.scss'],
    templateUrl: './deep-thought.component.html'
})
export class DeepThoughtComponent extends BaseComponent {
    /**
     * Menu config.
     */
    public menuConfig: MenuConfigModel;

    constructor(
        private authApiService: AuthApiService,
        private logService: LogService,
        private modalService: ModalService,
        private userService: UserService
    ) {
        super();

        this.menuConfig = DeepThoughtMenu;
    }

    /**
     * Logout helper function to open modal and close burger menu.
     */
    public openLogoutModal(): void {
        this.modalService.openModalInParent('logoutConfirm');
    }

    /**
     * Logout of the user interface
     */
    public logout(): void {
        this.modalService.closeAll();
        this.userService.logout();

        this.authApiService.invalidateJWT()
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (): void => {

                },
                error: (error: ErrorResponseModel): void => {
                    this.logService.error(
                        'DeepThoughtComponent: logout()',
                        'Failed to invalidate token - ' + error.message
                    );
                }
            });
    }
}
